"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeProxyTransactionData = void 0;
const utils_1 = require("ethers/lib/utils");
const abis_1 = require("../abis");
const factoryInterface = new utils_1.Interface(abis_1.proxyWalletFactory);
exports.encodeProxyTransactionData = (txns) => {
    return factoryInterface.encodeFunctionData("proxy((uint8,address,uint256,bytes)[])", [txns]);
};
